/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DoctorAttachment
 */
export interface DoctorAttachment {
    /**
     * 
     * @type {string}
     * @memberof DoctorAttachment
     */
    doctor_id: string;
}

/**
 * Check if a given object implements the DoctorAttachment interface.
 */
export function instanceOfDoctorAttachment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "doctor_id" in value;

    return isInstance;
}

export function DoctorAttachmentFromJSON(json: any): DoctorAttachment {
    return DoctorAttachmentFromJSONTyped(json, false);
}

export function DoctorAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'doctor_id': json['doctor_id'],
    };
}

export function DoctorAttachmentToJSON(value?: DoctorAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'doctor_id': value.doctor_id,
    };
}

